import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import { Documentation } from "../models/Documentation";

class DocumentatioService extends GenericCrudServiceV2<Documentation> {
  path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  getFormData(document: Documentation): FormData {
    const formData = new FormData();
    if (document) {
      if (document.file) {
        formData.append("file", document.file);
      }
    }

    return formData;
  }

  uploadDocument(document: Documentation): Promise<ApiResponseV2<Documentation>> {
    return HttpClientV2.post(`${this.path}/upload`, this.getFormData(document));
  }
}

export default new DocumentatioService("/ensolvers-ops/documents");
